export const ServiceItems = [
  {
    title: "Demolición e instalación de refractarios",
    image: "images/servicios/demolicion.png",
  },
  {
    title: "Limpieza de bunker y silos",
    image: "images/servicios/limpieza_bunker.png",
  },
  {
    title: "Sanblasteo y Pintura",
    image: "images/servicios/sanblasteo.png",
  },
  {
    title: "Renta de equipo",
    image: "images/servicios/renta_equipo.png",
  },
  {
    title: "Soldadura Industrial",
    image: "images/servicios/soldadura.png",
  },
]
